module.exports = __webpack_public_path__ + "static/media/76.0b2d1861.jpg";